import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Text from '../Text';
import { markFuzzyMatchSubstring, markStartsWithMatchSubstring } from './utils';

/**
 * Highlight or mark letters in a string using a provided query.
 */
function Highlight(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$marker = _ref.marker,
      marker = _ref$marker === void 0 ? markStartsWithMatchSubstring : _ref$marker,
      query = _ref.query,
      text = _ref.text,
      restProps = _objectWithoutPropertiesLoose(_ref, ["color", "marker", "query", "text"]);

  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "span"
  }, restProps), marker(text, query).map(function (part, index) {
    return /*#__PURE__*/React.createElement(Text, {
      key: index,
      inline: true,
      as: part.highlight ? 'mark' : 'span',
      color: part.highlight ? color : undefined,
      backgroundColor: "transparent",
      fontWeight: "inherit",
      fontSize: "inherit"
    }, part.text);
  }));
}

Highlight.FUZZY = markFuzzyMatchSubstring;
Highlight.STARTS_WITH = markStartsWithMatchSubstring;
export default Highlight;